var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75.25A6.257 6.257 0 00.5 6.5c0 3.343 2.645 6.059 5.95 6.22l-2.526 2.97a1.248 1.248 0 00.952 2.06c.354 0 .705-.15.952-.441C11.512 10.62 13 9.414 13 6.5A6.258 6.258 0 006.75.25zm0 10C4.682 10.25 3 8.568 3 6.535s1.682-3.75 3.75-3.75a3.754 3.754 0 013.75 3.75c0 2.068-1.684 3.715-3.75 3.715z",
    fill: "#00B9EF"
  })));
}

export default SvgNine;